<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


/* Triggers a click onto the button.mobileMenu-toggle (mobile menu) if a list item of the Sticky mobile toolbar a href contains "#" */

document.addEventListener('DOMContentLoaded', function() {
  const toolbar = document.querySelector('.halo-sticky-toolbar-mobile');

  if (toolbar) {
    toolbar.addEventListener('click', function(event) {
      let targetElement = event.target;

      // Traverse up the DOM to find the closest 'a' element
      while (targetElement !== null && targetElement.tagName !== 'A') {
        targetElement = targetElement.parentElement;
      }

      // Check if the 'a' element has an href of "#"
      if (targetElement && targetElement.getAttribute('href') === '#') {
        event.preventDefault(); // Prevent the default behavior of the link
        const mobileMenuButton = document.querySelector('.mobileMenu-toggle');
        if (mobileMenuButton) {
          mobileMenuButton.click();
        }
      }
    });
  }
});



